import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import GridWrapper from "../../../components/controls/GridWrapper";
import { TextInput } from "../../../components/controls/inputs";
import BaseCreator from "../../../components/creators/baseCreator";
import { useForm } from "../../../system/hooks/useForm";
import modalStyles from '../../../components/modalWindows/styles/BaseModalWindow.module.scss'
import { IFinancialSecurityGetDTO } from "../../../libs/coreapi-dto/dirs/financialSecurity";
type Validator = Pick<IFinancialSecurityGetDTO, 'code'>

const FinancialSecurityCreatorModal: FC<ICreatorModalProps<IFinancialSecurityGetDTO>> = (props) => {

    const [financialSecurity, setFinancialSecurity] = useState<IFinancialSecurityGetDTO>(props.data ?? {} as IFinancialSecurityGetDTO);

    const { t } = useTranslation();
    const baseT = (value: string) => t('directory.financialSecurity.' + value);
    const errorsT = (value: string) => t('errors.' + value);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const { isValid, errors, setErrors } = useForm<Validator>({
        validations: {
            code: {
                required: {
                    value: financialSecurity.code ? false : true,
                    message: errorsT("required")
                }
            },
        }
    });

    const handleSubmit = () => {
        if (isValid()) {
            props.save({ ...financialSecurity })
            setIsSubmitting(true)
        }
    }

    return (
        <BaseCreator
            modalWindowClassName={modalStyles.flexModalWindow}
            variant={props.variant}
            isSubmitting={isSubmitting}
            save={handleSubmit}
            cancel={props.cancel}
            valid={!props.lockFromPermission}
        >
            <GridWrapper cols={1}>
                <TextInput
                    label={baseT('mnemocode')} value={financialSecurity.mnemocode}
                    disabled={true}
                />
            </GridWrapper>
            <GridWrapper cols={2}>
                <TextInput
                    labelVariant="required"
                    required
                    label={baseT('code')} 
                    value={financialSecurity.code}
                    onChange={(value) => setFinancialSecurity({ ...financialSecurity, code: value })}
                    error={errors.code} onFocus={() => setErrors({ ...errors, code: undefined })} 
                    disabled={props.lockFromPermission}
                />
                <TextInput
                    label={baseT('description')} value={financialSecurity.description}
                    onChange={(value) => setFinancialSecurity({ ...financialSecurity, description: value })}
                    disabled={props.lockFromPermission}
                />

            </GridWrapper>
          
        </BaseCreator>
    )
}

export default FinancialSecurityCreatorModal